var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MobileServiceOverview',_vm._b({staticClass:"industry-view",attrs:{"hero-image":_vm.industryHeroImage}},'MobileServiceOverview',_vm.industryOverview,false))
}
var staticRenderFns = []

export { render, staticRenderFns }